import { accessRole } from "../../../../helpers/access_role";
import apiResponse from "../../../../services/apiResponse"
import React, { Fragment,Component } from "react"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle, Table, Button
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

import Shimmer from "react-shimmer-effect";

import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"
import ApproveBloc from "./Blocs/ApproveBloc"
import CustomSelect from '../../GlobalComponents/CustomSelect'

class IndexView extends Component {

    approveBloc = new ApproveBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    constructor(props) {
      super(props)
        this.state = {
            dataForm: {},
            optionStatusApproval : [
              { label: "Disetujui", value: 1 },
              { label: "Ditolak", value: 2 }
            ],
            data_status : 0,
            isLocal: null
        }
    }

    submitData = async () => {
        await this.approveBloc.fetchApprove(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              uuid: this.state.detail.employee_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount(){ 
      this.approveBloc.approveChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  this.setState({
                      loading: false,
                      success: true,
                  });
                  break
              case apiResponse.ERROR:
                  this.setState({
                      loading: false,
                      failed: true,
                  });
                  break
              default:
                  break
          }
      }) 

      this.approveBloc.detailChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      // this.setState({
                      //     detail: response,
                      //     data_status: (response != null ? response.employee_status : 0)
                      // })

                      let response_current = result.data.response.current
                      let response_history = result.data.response.history
                      this.setState({
                          detail: response_current,
                          dataForm: {
                              status: 1,
                              uuid : response_current.employee_uuid,
                              data_status: (response != null ? response_current.employee_status : 0),
                              isLocal: (response != null ? (response_current.employee_place_of_birth_national == "Dalam Negeri" ? 1 : 0) : 0),
                          },
                          history: response_history
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      //const peg_uuid = "86e6f2af-1c9a-40c1-8845-594e2e3797b3";
      this.approveBloc.fetchDetail({uuid: this.peg_uuid, history: 1 })

      const queryParams = new URLSearchParams(this.props.location.search)

      /* 
        If Administrator
        Set Employee Selected on localstorage by Notification Click 
      */
      try {
          let causer = queryParams.get('causer')

          if (causer != null){
              let arrCauser = atob(causer).split('|');
  
              let dataUser = {
                  employee_uuid: arrCauser[1],
                  employee_name : arrCauser[0],
                  employee_current_position_name : arrCauser[2],
                  employee_nip : arrCauser[3]
              }
              localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
              //console.log(arrCauser);
          }
      } catch (error) {}
    }

    componentWillUnmount(){
        this.approveBloc.detailChannel.unsubscribe()
        this.approveBloc.approveChannel.unsubscribe()
    }

    render(){
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                        <PegawaiSideBar active="identitas"/>
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Card className="pegawai-rightbar">
                                    <CardBody>
                                        <CardTitle>Approve Identitas Pegawai</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_name !== "" ? this.state.detail.employee_name : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </CardSubtitle>
                                        <hr />
                                        {
                                        this.state.history ?
                                          <Row className="mb-3">
                                              <label className="col-md-3">
                                                  
                                              </label>
                                              <Col md="5">
                                                  <strong> Data Baru </strong>
                                              </Col>
                                              <Col md="4">
                                                  <strong className="text-danger"> Data Lama </strong>
                                              </Col>
                                          </Row>
                                        : '' }

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP Lama
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip_old !== "" ? this.state.detail.employee_nip_old : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_nip_old !== "" ? this.state.history.employee_nip_old : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP Baru
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_nip !== "" ? this.state.history.employee_nip : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama Lengkap
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_name !== "" ? this.state.detail.employee_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_name !== "" ? this.state.history.employee_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                              Gelar Non Akademi Depan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_front_title_non_academic !== "" ? this.state.detail.employee_front_title_non_academic : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_front_title_non_academic !== "" ? this.state.history.employee_front_title_non_academic : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Gelar Non Akademi Belakang
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_end_title_non_academic !== "" ? this.state.detail.employee_end_title_non_academic : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_end_title_non_academic !== "" ? this.state.history.employee_end_title_non_academic : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                              Gelar Depan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_front_title !== "" ? this.state.detail.employee_front_title : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="5">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_front_title !== "" ? this.state.history.employee_front_title : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Gelar Belakang
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_end_title !== "" ? this.state.detail.employee_end_title : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_end_title !== "" ? this.state.history.employee_end_title : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        
                                        <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Lahir Dalam / Luar Negeri
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_place_of_birth_national !== "" ? this.state.detail.employee_place_of_birth_national : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_place_of_birth_national !== "" ? this.state.history.employee_place_of_birth_national : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Negara Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_place_of_birth_country_name !== "" ? this.state.detail.employee_place_of_birth_country_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_place_of_birth_country_name !== "" ? this.state.history.employee_place_of_birth_country_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3" style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                            <label className="col-md-3">
                                                Provinsi Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_place_of_birth_province_name !== "" ? this.state.detail.employee_place_of_birth_province_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_place_of_birth_province_name !== "" ? this.state.history.employee_place_of_birth_province_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3" style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                            <label className="col-md-3">
                                                Kota Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_place_of_birth_city_name !== "" ? this.state.detail.employee_place_of_birth_city_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_place_of_birth_city_name !== "" ? this.state.history.employee_place_of_birth_city_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3" style={ this.state.isLocal == 1 ? {display:'none'} : {}}>
                                            <label className="col-md-3">
                                                Kota Lahir (Free Text)
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_place_of_birth_city_text !== "" ? this.state.detail.employee_place_of_birth_city_text : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_place_of_birth_city_text !== "" ? this.state.history.employee_place_of_birth_city_text : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal Lahir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_date_of_birth !== "" ? this.state.detail.employee_date_of_birth : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_date_of_birth !== "" ? this.state.history.employee_date_of_birth : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jenis Kelamin
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_gender_name !== "" ? this.state.detail.employee_gender_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_gender_name !== "" ? this.state.history.employee_gender_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Agama
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_religion_name !== "" ? this.state.detail.employee_religion_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_religion_name !== "" ? this.state.history.employee_religion_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Pernikahan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_marital_status_name !== "" ? this.state.detail.employee_marital_status_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_marital_status_name !== "" ? this.state.history.employee_marital_status_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Golongan darah
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_blood_type_name !== "" ? this.state.detail.employee_blood_type_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_blood_type_name !== "" ? this.state.history.employee_blood_type_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Alamat Tinggal
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_domicile_address !== "" ? this.state.detail.employee_domicile_address : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_domicile_address !== "" ? this.state.history.employee_domicile_address : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Provinsi
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_domicile_province_name !== "" ? this.state.detail.employee_domicile_province_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_domicile_province_name !== "" ? this.state.history.employee_domicile_province_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kabupaten/Kota
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_domicile_city_name !== "" ? this.state.detail.employee_domicile_city_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_domicile_city_name !== "" ? this.state.history.employee_domicile_city_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kecamatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_domicile_districts_name !== "" ? this.state.detail.employee_domicile_districts_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_domicile_districts_name !== "" ? this.state.history.employee_domicile_districts_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Desa/Kelurahan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_domicile_village_name !== "" ? this.state.detail.employee_domicile_village_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_domicile_village_name !== "" ? this.state.history.employee_domicile_village_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kode Pos
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_domicile_postal_code !== "" ? this.state.detail.employee_domicile_postal_code : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_domicile_postal_code !== "" ? this.state.history.employee_domicile_postal_code : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Alamat KTP
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_address !== "" ? this.state.detail.employee_identity_address : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_address !== "" ? this.state.history.employee_identity_address : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Provinsi
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_province_name !== "" ? this.state.detail.employee_identity_province_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_province_name !== "" ? this.state.history.employee_identity_province_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kabupaten/Kota
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_city_name !== "" ? this.state.detail.employee_identity_city_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_city_name !== "" ? this.state.history.employee_identity_city_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kecamatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_districts_name !== "" ? this.state.detail.employee_identity_districts_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_districts_name !== "" ? this.state.history.employee_identity_districts_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Desa/Kelurahan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_village_name !== "" ? this.state.detail.employee_identity_village_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_village_name !== "" ? this.state.history.employee_identity_village_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kode Pos
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_postal_code !== "" ? this.state.detail.employee_identity_postal_code : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_postal_code !== "" ? this.state.history.employee_identity_postal_code : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Bank
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_bank_name !== "" ? this.state.detail.employee_bank_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_bank_name !== "" ? this.state.history.employee_bank_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Rekening Gaji
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_bank_account_number !== "" ? this.state.detail.employee_bank_account_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_bank_account_number !== "" ? this.state.history.employee_bank_account_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_current_work_unit_name !== "" ? this.state.history.employee_current_work_unit_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_current_position_name !== "" ? this.state.history.employee_current_position_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tipe Pegawai
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_type_name !== "" ? this.state.detail.employee_type_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_type_name !== "" ? this.state.history.employee_type_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Pegawai
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_status_name !== "" ? this.state.detail.employee_status_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_status_name !== "" ? this.state.history.employee_status_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Penggajian
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_salary_paid_from !== "" ? this.state.detail.employee_salary_paid_from : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_salary_paid_from !== "" ? this.state.history.employee_salary_paid_from : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Keterangan Status
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_status_description_name !== "" ? this.state.detail.employee_status_description_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_status_description_name !== "" ? this.state.history.employee_status_description_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal Pensiun
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_date_of_pension !== "" ? this.state.detail.employee_date_of_pension : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_date_of_pension !== "" ? this.state.history.employee_date_of_pension : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                TMT Pensiun
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_tmt_pension !== "" ? this.state.detail.employee_tmt_pension : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_tmt_pension !== "" ? this.state.history.employee_tmt_pension : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kedudukan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_status_position_name !== "" ? this.state.detail.employee_status_position_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_status_position_name !== "" ? this.state.history.employee_status_position_name : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kartu Pegawai
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_karpeg_number !== "" ? this.state.detail.employee_karpeg_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_karpeg_number !== "" ? this.state.history.employee_karpeg_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Askes / BPJS Kesehatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_askes_number !== "" ? this.state.detail.employee_askes_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_askes_number !== "" ? this.state.history.employee_askes_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tapera
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_tapera_number !== "" ? this.state.detail.employee_tapera_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_tapera_number !== "" ? this.state.history.employee_tapera_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Taspen
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_taspen_number !== "" ? this.state.detail.employee_taspen_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_taspen_number !== "" ? this.state.history.employee_taspen_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NPWP
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_npwp_number !== "" ? this.state.detail.employee_npwp_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_npwp_number !== "" ? this.state.history.employee_npwp_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIK
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_identity_number !== "" ? this.state.detail.employee_identity_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_identity_number !== "" ? this.state.history.employee_identity_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                No. Dosir
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_dosir_number !== "" ? this.state.detail.employee_dosir_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_dosir_number !== "" ? this.state.history.employee_dosir_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Telepon Rumah
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_phone_number !== "" ? this.state.detail.employee_phone_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_phone_number !== "" ? this.state.history.employee_phone_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Handphone
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_mobile_phone_number !== "" ? this.state.detail.employee_mobile_phone_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_mobile_phone_number !== "" ? this.state.history.employee_mobile_phone_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Email Office 365
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_email_internal !== "" ? this.state.detail.employee_email_internal : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_email_internal !== "" ? this.state.history.employee_email_internal : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Email Eksternal
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_email_external !== "" ? this.state.detail.employee_email_external : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_email_external !== "" ? this.state.history.employee_email_external : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Lokasi Kerja
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.work_unit_location_full_address !== "" ? this.state.detail.work_unit_location_full_address : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.work_unit_location_full_address !== "" ? this.state.history.work_unit_location_full_address : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Enroll
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_enroll_number !== "" ? this.state.detail.employee_enroll_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_enroll_number !== "" ? this.state.history.employee_enroll_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                ID SAPK BKN
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_sapk_bkn_id !== "" ? this.state.detail.employee_sapk_bkn_id : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_sapk_bkn_id !== "" ? this.state.history.employee_sapk_bkn_id : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                File Pendukung
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>
                                                            {this.state.detail.document !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>
                                                            {this.state.history.document !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.history.document.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        {/* Tambahan Kartu Keluarga */}
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Kartu Keluarga
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_family_card_number !== "" ? this.state.detail.employee_family_card_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.employee_family_card_number !== "" ? this.state.history.employee_family_card_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                File Kartu Keluarga
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>
                                                            {this.state.detail.document_kk !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_kk.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>
                                                            {this.state.history.document_kk !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.history.document_kk.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="status_approval"
                                                    errorMessage="Pilih Status Approval"
                                                    options={this.state.optionStatusApproval} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="status_approval_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="7">
                                                <AvField
                                                    name="status_approval_description"
                                                    placeholder="Keterangan Approval..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan Approval"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval_description"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Button 
                                                  color="success" 
                                                  type="submit"
                                                >
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                {' '}
                                                <Link to="/kepegawaian/home.html?identitas">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                
                                            </Col>
                                        </Row>
                                        
                                    </CardBody>
                                </Card>
                            
                            </AvForm>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan approval untuk data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?identitas'/>
                : null }
            </Fragment>
        )
    }
}
export default withRouter(IndexView);